module.exports = __webpack_public_path__ + "static/media/person-2.94f56144.png";